import React from 'react';
import { Paper } from '@mui/material';

interface HubCardProps {
  children: React.ReactNode;
  // Tighter padding for the small side-by-side cards
  dense?: boolean;
}

const HubCard = ({ children, dense = false }: HubCardProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: dense ? { xs: 2, md: 2.5 } : 3,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Paper>
  );
};

export default HubCard;